export const getManagePasswordSubmitAnalytics = (status = "", errors = []) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "my account:account settings:modal:manage password:submit",
    eventName: "my account:account settings:modal:manage password:submit",
    eventType: "navigation",
    eventMsg: errors ? errors.join("|")?.toLowerCase() : "n/a",
    eventStatus: status,
    internalLinkName: "submit",
    internalLinkPosition: "my account",
    internalLinkType: "my account:login & security",
    internalLinkZoneName: "my account:account settings:modal:manage password",
    internalLinkURL: "n/a",
    formName: "manage password",
  }

  window?.adobeDataLayer?.push({
    event: "cmp:click",
    eventInfo,
  })
  delete window?.pageObj
}
